import { RulesSettings } from '@components/settings/rules'

// Admin Tools → Calibration Rules. Thin page shell over the rule-library table,
// which was built as a settings panel and is fully self-contained (CAR-3778).
export const CalibrationRulesPage = () => <RulesSettings />
